import React, { useMemo } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import MyAccountSideOptions from "../../Pages/myAccount/sideBarSection";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function MyAccount({ userAction, setUserAction }) {
  const { width } = useWindowDimensions();

  const handleClose = () => {
    setUserAction({});
  };

  const isOpen = useMemo(() => {
    return width <= 992 && userAction?.action === "showMyAccountOptions";
  }, [width, userAction]);

  return (
    <>
      <Drawer
        open={isOpen}
        onClose={handleClose}
        lockBackgroundScroll={true}
        direction="right"
        className="myAccountDrawer"
      >
        <MyAccountSideOptions
          wrapperClassName="d-block bg-white text-dark"
          handleClose={handleClose}
        />
      </Drawer>
    </>
  );
}
